import type { i18n } from 'i18next';
import { LANGUAGE_QUERY_PARAMETER } from './language';

export function formatLink(t: string, i18n: i18n) {
  return formatEmbeddableLink(t, false, i18n);
}

export function formatEmbeddableLink(t: string, embedded: boolean, i18n: i18n) {
  const lang = i18n.language;
  const url = new URL(window.location.href);
  if (url.hostname !== 'localhost') {
    url.hostname = `${import.meta.env.VITE_SHARE_PREFIX}.${url.hostname}`;
  }
  // ha van a vegen # akkor letoroljuk
  url.hash = '';
  // ha van search param akkor toroljuk
  url.search = '';
  url.searchParams.set('t', t);
  url.searchParams.set(LANGUAGE_QUERY_PARAMETER, lang);

  url.pathname = '/tracking';

  if (embedded) {
    return `<iframe src="${url.toString()}" width="800" height="600"></iframe>`;
  } else {
    return url.toString();
  }
}

export async function copyClipboard(link: string | undefined) {
  if (!link) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(link);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
}
